import React from 'react';
import "components/Parts/CalendarParts/css/custom-calendar.scss"
import "react-big-calendar/lib/css/react-big-calendar.css"
import moment from 'moment'
import Card from "@material-ui/core/Card";

const Event = ({event, forFe}) => {
	let startTime = moment(event.start).format("LT")
	let endTime = moment(event.end).format("LT")
	if ((startTime.includes('AM') && endTime.includes('AM')) || (startTime.includes('PM') && endTime.includes('PM'))) {
		startTime = startTime.slice(0, -3);
	}
	startTime = event.fe_start ? event.fe_start.replace(':00', '') : startTime.replace(':00', '');
	endTime = event.fe_end ? event.fe_end.replace(':00', '') : endTime.replace(':00', '');
	//if all day events
	//TODO: need to add FE times in these I think, need to check with Matt about that
	//Need to also probably just see if the dates are a day apart and then dont show time
	let displayTime = (startTime === '12' && endTime === '12 AM') || event.allDay === true ? null : (startTime + '-' + endTime)
	let description = (startTime === '12' && endTime === '12 AM') || event.allDay === true ? null : (event.location ? event.location : event.description)
	let actioned_string = '';
	if (event.actioned) {
		event.color = 'grey'
		let day_string = '';
		let time_string = '';
		if (event.actioned_on) {
			day_string = moment(event.actioned_on).format('MM/DD/YY');
			time_string = moment(event.actioned_on).format('h:mm a');
		}
		actioned_string = day_string ? `(Completed by FE on ${day_string} at ${time_string})` : "(Completed by FE)"
	}
	if (forFe) {
		return (<Card style={{paddingTop: 10, paddingBottom: 10, borderRadius: 10, backgroundColor: event.ticket ? '#0275D8' : event.color, width: '98%'}}>
			<div style={{display: 'flex', alignItems: 'center', flexFlow: 'column'}}>
				<div style={{fontWeight: "bold", fontSize: 25, textDecoration: event.actioned ? 'line-through' : 'none'}}>
					{event.ticket ? event.customer : event.title} {event.actioned ? actioned_string : ''}
				</div>
				<div style={{fontSize: 20, textDecoration: event.actioned ? 'line-through' : 'none'}}>
					{displayTime}
				</div>
				<br/>
				{description}
			</div>
		</Card>);
	} else {
		return (<span>
			<div style={{fontWeight: "bold", textDecoration: event.actioned ? 'line-through' : 'none'}}>
				{event.ticket ? event.customer : event.title} {event.actioned ? actioned_string : ''}
			</div>
			<div style={{fontSize: 12, textDecoration: event.actioned ? 'line-through' : 'none'}}>
				{displayTime}
			</div>
			<br/>
			{description}
		</span>);
	}
};
export default Event
